<div [id]="containerId" class="lottie-container"></div>